export default "__VITE_ASSET__D7oYPdC3__"